import { getToken } from "@src/utils/token";
import { toast } from "react-toastify";

const updateUser = async (formData) => {
  const token = getToken();

  if (!token) {
    toast.error("توکن یافت نشد");
    return;
  }

  try {
    const updatedUserData = {
      ...formData,
      birthday:
        Array.isArray(formData.birthday) && formData.birthday.length > 0
          ? new Date(formData.birthday[0]).toISOString()
          : typeof formData.birthday === "object" && formData.birthday?.toDate?.()
            ? formData.birthday.toDate().toISOString()
            : typeof formData.birthday === "string"
              ? new Date(formData.birthday).toISOString()
              : "",
    };

    const res = await fetch("https://api.marvellife.co/api/v2/users/registerUser", {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        "x-auth-token": token,
      },
      body: JSON.stringify(updatedUserData),
    });

    if (!res.ok) {
      const errorData = await res.json();
      const message = errorData?.message;
      toast.error(message);
      throw new Error(message);
    }

    toast.success("اطلاعات با موفقیت ثبت شد");
    return await res.json();
  } catch (error) {
    throw error;
  }
};

export default updateUser;
